import styled from 'styled-components'

export const FeatureShowcaseStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 38fr) minmax(0, 59fr);
  gap: ${(props) => props.theme.space.xlarge};
  align-items: start;

  @media (max-width: ${(props) => props.theme.typography.pxToRem(1160)}) {
    grid-template-columns: minmax(0, 1fr);
  }

  .bill-pay-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
